import styled from 'styled-components';

export const StyledText = styled.div`
  font-size: 0.875rem;
  line-height: 1rem;
  margin: 0 auto 1rem;
  max-width: 17.25rem;
  text-align: center;
`;
